import { render, staticRenderFns } from "./TgCardItem.vue?vue&type=template&id=08d2c511&"
import script from "./TgCardItem.vue?vue&type=script&lang=js&"
export * from "./TgCardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports